<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Salida de inventario</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-5">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'inventario-salida_inventario-nuevo', params: {} }"
              >
                <i class="fa fa-pencil"></i>
                Nueva salida de inventario
              </router-link>
            </div>
            <div class="col-sm-12">
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Filtrar por número"
                  v-model="filter.numero"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filter.estado_str"
                  @change="filterData()"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <SalidaInventarioTableComponent :dataTabla="datatabla2" />
        <PaginationComponent
          :currentPage="currentPage"
          :data="datatabla2"
          @pagechanged="filterData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import SalidaInventarioTableComponent from "@/components/inventario/salida_inventario/SalidaInventarioTableComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    SalidaInventarioTableComponent,
    UsuarioEnTablaComponent,
    UsuariosSelectComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      datatabla2: "",
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        fecha_creacion: "",
        numero: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.refreshData();
  },
  methods: {
    modalTiendaSelect() {
      $("#modalTiendaSelect").modal("show");
    },
    refreshData() {
      DynamicService.fetch("inv", "sal_inventario", {}).then((response) => {
        this.datatabla2 = response.data;
      });
    },
    filterData(page) {
      if (page) {
        this.currentPage = page;
      }
      DynamicService.fetch("inv", "sal_inventario", {
        page: this.$data.currentPage,
        estado: this.filter.estado_str,
        numero: this.filter.numero,
      }).then((response) => {
        this.datatabla2 = response.data;
      });
    },
    clearFilterData() {
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.numero = "";
      this.filter.usuario = "";
      this.filter.tienda = "";
      this.refreshData()
    },
  },
};
</script>
